/** The mark a past ticket wears for where a Mocked run's tool answers come from. A fabricated scenario wears none. */

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { Scenario } from '../types';
import { TICKET_SOURCE_LABELS, ticketSource, ticketSourceHint, type TicketSource } from './ticket-source';

const SOURCE_TONES: Record<TicketSource, string> = {
	recorded: 'border-teal-200 bg-teal-50 text-teal-700',
	imported: 'text-gray-800'
};

export const TicketSourceBadge = ({ scenario }: { scenario: Pick<Scenario, 'kind' | 'recording'> }) => {
	const source = ticketSource(scenario);
	return source ? (
		<Badge
			variant='outline'
			title={ticketSourceHint(scenario) ?? undefined}
			className={cn('text-[10px]', SOURCE_TONES[source])}
		>
			{TICKET_SOURCE_LABELS[source]}
		</Badge>
	) : null;
};
